<!-- <p-blockUI fxFlex="1 1 auto" [target]="explainPanel" [blocked]="panelBlocked"> -->
<!-- <i class="fa fa-spin fa-circle-o-notch fa-5x" style="position:absolute;top:50%;left:50%"></i> -->
<!-- </p-blockUI> -->
<div fxFlex="0 0 100%" fxLayout="column">
    <div class="explain-bar" fxFlex="0 0 auto" fxLayout="row" fxLayoutGap="2em">
        <span class="explain-currency" fxFlex="1 0 auto" fxFlexAlign="left">Currency: {{explainedCurrency | uppercase}}</span>
        <span class="explain-date" fxFlex="1 0 auto" fxFlexAlign="left">Date: {{explainedDate}}</span>
        <span *ngIf="!panelBlocked" fxFlex="5 5 grow" fxFlexAlign="center"></span>
        <p-progressBar *ngIf="panelBlocked" mode="indeterminate" [style]="{'height': '6px'}" fxFlex="5 5 grow" fxFlexAlign="center"></p-progressBar>
        <span class="explain-time" fxFlex="1 0 auto" fxFlexAlign="right">{{explainedRequestTime}}</span>
    </div>
    <div #explainPanel fxFlex="1 1 auto" fxLayout="column">
        <div fxFlex="1 1 100%" fxLayout="row" fxLayout.lt-sm="column">
            <div class="explain-charts" fxFlex="0 0 50%" fxFlex.lt-md="1 1 auto" fxLayout="column">
                <div fxFlex="0 0 15%" class="liquidity-mode-toggle">
                    <mat-button-toggle-group (change)="onLiquidityModeChange($event)">
                        <mat-button-toggle value="gross" [checked]="liquidityMode === 'gross'">
                            <span>Gross</span>
                        </mat-button-toggle>
                        <mat-button-toggle value="net" [checked]="liquidityMode === 'net'">
                            <span>Net</span>
                        </mat-button-toggle>
                        <mat-button-toggle value="in" [checked]="liquidityMode === 'in'">
                            <span>In</span>
                        </mat-button-toggle>
                        <mat-button-toggle value="out" [checked]="liquidityMode === 'out'">
                            <span>Out</span>
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <div fxFlex="0 0 85%" class="chartwrapper">
                    <div id="explainchartdiv" class="chartdiv"></div>
                </div>
                <!-- <div *ngIf="explainMode === 'BY_SOURCE'" fxFlex="0 0 35%" class="legendwrapper">
                    <div id="explainlegenddiv" class="legenddiv"></div>
                </div> -->
            </div>
            <div *ngIf="explainMode !== 'BY_SOURCE'" [fxHide]="pulledOut" fxFlex="0 0 50%" class="legendwrapper">
                <div id="explainlegenddiv" class="legenddiv"></div>
            </div>
            <app-explain-tables class="explain-table" [fxHide]="!(explainMode === 'BY_SOURCE' || pulledOut)" fxFlex="0 0 50%" fxFlex.lt-sm="1 1 auto"></app-explain-tables>
        </div>
    </div>
    <!-- <div *ngIf="panelBlocked || 1==1" class="overlay">
        <i class="fa fa-spin fa-circle-o-notch fa-5x" style="position:absolute;top:50%;left:50%"></i>
    </div> -->
</div>